import React from 'react'
import queryString from 'query-string'
import { useLocation, Link } from 'react-router-dom'
import { ChevronLeft, ChevronRight } from '@icons'

const paginator = (totalItems, currentPage, limit) => {
  let page = currentPage || 1,
    perPage = limit || 10,
    totalPages = Math.ceil(totalItems / perPage)

  return {
    page: page,
    perPage: perPage,
    prevPage: page - 1 ? page - 1 : null,
    nextPage: totalPages > page ? page + 1 : null,
    totalPages: totalPages,
  }
}

const Pagination = ({ totalItems, currentPage, limit }) => {
  const location = useLocation()

  const { page, prevPage, nextPage } = paginator(totalItems, currentPage, limit)

  const getLink = (page) => {
    const query = queryString.parse(location.search)
    query.page = page
    return `?${queryString.stringify(query)}`
  }

  return (
    <nav>
      <ul className="pagination justify-content-center bg-waring">
        <li className={`page-item ${!prevPage && 'disabled'}`}>
          <a
            className="page-link"
            href={getLink(prevPage)}
            aria-label="Previous"
          >
            <span aria-hidden="true">
              <ChevronLeft fill="#0d6efd" />
            </span>
          </a>
        </li>
        {prevPage && (
          <li className="page-item">
            <a href={getLink(prevPage)} className="page-link">
              {prevPage}
            </a>
          </li>
        )}
        <li className="page-item active">
          <Link to="#" className="page-link">
            {page}
          </Link>
        </li>
        {nextPage && (
          <li className="page-item">
            <a href={getLink(nextPage)} className="page-link">
              {nextPage}
            </a>
          </li>
        )}
        <li className={`page-item ${!nextPage && 'disabled'}`}>
          <a
            className="page-link"
            href={getLink(nextPage)}
            aria-label="Previous"
          >
            <span aria-hidden="true">
              <ChevronRight fill="#0d6efd" />
            </span>
          </a>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
